import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import it from "./locales/it.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import zh from "./locales/zh.json";

i18n.use(LanguageDetector).use(initReactI18next).init({
  resources: {
    it: { translation: it },
    en: { translation: en },
    fr: { translation: fr },
    de: { translation: de },
    zh: { translation: zh },
  },
  fallbackLng: "it",
  supportedLngs: ["it", "en", "fr", "de", "zh"],
  interpolation: { escapeValue: false },
  detection: {
    order: ["localStorage", "navigator"],
    lookupLocalStorage: "xenia_lang",
    caches: ["localStorage"],
  },
});

export default i18n;
